import hsFetch from 'hellospa/hs-fetch';
import { PrepAndSendSuccess, HsErrorResponse, TemplateList, Template } from 'hellospa/components/integration/data/types';
import * as Yup from 'yup';

const templateSchema: Yup.ObjectSchema<Template> = Yup.object<Template>({
  templateId: Yup.string(),
  title: Yup.string(),
  isLocked: Yup.boolean(),
  canEdit: Yup.boolean(),
  // Add template response properties here when needed
}).camelCase();

const templateArraySchema = Yup.array().of(templateSchema);

export async function unclaimedDraftCreateEmbedded(
  associatedObjectId: number,
  associatedObjectType: string,
  identifier: string,
  context: string,
)
: Promise<PrepAndSendSuccess | HsErrorResponse> {

  const body = {
    associatedObjectId,
    associatedObjectType,
    identifier,
    context,
  };

  const response = await hsFetch('/integration/unclaimedDraftCreateEmbedded', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });

  const resp = await response.json();

  if (resp.claim_url) {
    return {
      signatureRequestId: resp.signature_request_id,
      claimUrl: resp.claim_url,
      clientId: resp.client_id,
      success: true,
    } as PrepAndSendSuccess;
  } else {
    return {
      error: resp.error,
      statusCode: response.status,
      success: false,
    } as HsErrorResponse;
  }
}

export async function unclaimedDraftCreateEmbeddedWithTemplate(
  associatedObjectId: number,
  associatedObjectType: string,
  identifier: string,
  context: string,
  templateId: string,
)
: Promise<PrepAndSendSuccess | HsErrorResponse> {

  const body = {
    associatedObjectId,
    associatedObjectType,
    identifier,
    context,
    templateId,
  };

  const response = await hsFetch('/integration/unclaimedDraftCreateEmbeddedWithTemplate', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });

  const resp = await response.json();

  if (resp.claim_url) {
    return {
      signatureRequestId: resp.signature_request_id,
      claimUrl: resp.claim_url,
      clientId: resp.client_id,
      success: true,
    } as PrepAndSendSuccess;
  } else {
    return {
      error: resp.error,
      statusCode: response.status,
      success: false,
    } as HsErrorResponse;
  }
}

export async function templateList(
  associatedObjectId: number,
  associatedObjectType: string,
  identifier: string,
  context: string,
  pageSize: number,
  pageNum: number,
  query: string,
) : Promise<TemplateList | HsErrorResponse> {

  const body = {
    associatedObjectId,
    associatedObjectType,
    identifier,
    context,
    pageSize,
    pageNum,
    query,
  };

  const response = await hsFetch('/integration/templateList', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });

  const resp = await response.json();

  if ('templates' in resp) {
    const templates = await templateArraySchema.validate(resp.templates);
    return {
      templates,
      listInfo: {
        numPages: resp.list_info.page_size,
        numResults: resp.list_info.num_results,
        page: resp.list_info.page,
        pageSize: resp.list_info.page_size,
      },
    } as TemplateList;
  } else {
    return {
      error: resp.error,
      statusCode: response.status,
      success: false,
    } as HsErrorResponse;
  }

}

export async function templateCreateEmbeddedDraft(
  associatedObjectId: number,
  associatedObjectType: string,
  identifier: string,
  context: string,
)
: Promise<PrepAndSendSuccess | HsErrorResponse> {

  const body = {
    associatedObjectId,
    associatedObjectType,
    identifier,
    context,
  };

  const response = await hsFetch('/integration/templateCreateEmbeddedDraft', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });

  const resp = await response.json();

  if (resp.edit_url) {
    return {
      signatureRequestId: resp.signature_request_id,
      claimUrl: resp.edit_url,
      clientId: resp.client_id,
      success: true,
    } as PrepAndSendSuccess;
  } else {
    return {
      error: resp.error,
      statusCode: response.status,
      success: false,
    } as HsErrorResponse;
  }
}
